import { ACTION_TYPES } from "../constants/actionTypes";

const defaultState = {
  firstName: "",
  lastName: "",
  isLoading: false,
  isLogIn: false,
  userOnDashboard: false,
  currenrScreen: "/",
  requestId: null,
  accessToken: null,
  baUid: null,
  accountStatus: null,
  accountDetail: {},
  selectedRiskIndex: 0
};

const app = (state = defaultState, action) => {
  switch (action.type) {
    case ACTION_TYPES.APP.LOGOUT: {
      return { ...defaultState };
    }

    case ACTION_TYPES.APP.SET_LOADING: {
      return { ...state, isLoading: action.data };
    }

    case ACTION_TYPES.APP.LOGIN.INIT: {
      return { ...state, isLoading: true };
    }

    case ACTION_TYPES.APP.SET_REQUEST_ID: {
      return { ...state, requestId: action.data };
    }

    case ACTION_TYPES.APP.LOGIN.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLogIn: true,
        accessToken: action.data.access_token,
        baUid: action.data.ba_uid,
      };
    }

    case ACTION_TYPES.APP.LOGIN.FAIL: {
      return { ...state, isLoading: false };
    }

    case ACTION_TYPES.APP.DASHBOARD.INIT: {
      return { ...state, isLoading: true };
    }

    case ACTION_TYPES.APP.DASHBOARD.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        userOnDashboard: action.data.is_onboarded,
        accountStatus: action.data.account_status,
        accountDetail: action.data.details,
      };
    }

    case ACTION_TYPES.APP.DASHBOARD.FAIL: {
      return { ...state, isLoading: false };
    }

    case ACTION_TYPES.APP.USER_PROFILE.INIT: {
      return { ...state, isLoading: true };
    }

    case ACTION_TYPES.APP.USER_PROFILE.SUCCESS: {
      return { ...state, isLoading: false };
    }

    case ACTION_TYPES.APP.USER_PROFILE.FAIL: {
      return { ...state, isLoading: false };
    }

    case ACTION_TYPES.APP.SET_IS_LOGIN: {
      return { ...state, isLogIn: action.data };
    }

    case ACTION_TYPES.APP.USER_ON_DASHBOARD: {
      return { ...state, userOnDashboard: action.data };
    }

    case ACTION_TYPES.APP.USER_CURRENT_SCREEN: {
      return { ...state, currenrScreen: action.data };
    }

    case ACTION_TYPES.APP.SELECTED_RISK_INDEX: {
      return { ...state, selectedRiskIndex: action.data}
    }
    default:
      return state;
  }
};

export default app;
